import { Control, Controller } from 'react-hook-form';

import { ArtiaButtonLink } from '@/components/artia-button';
import { CurrencyTextInput } from '@/components/form-controls';
import { CalculationDetails } from '@/types/calculation-details';
import { OverridableCalculatedValue } from '@/types/overridable-calculated-value';
import { formatCurrency } from '@/utils/formatting';

type EstimatedUroaCellProps = {
  ndc: string,
  uroa?: OverridableCalculatedValue,
  onViewCalculationDetails: (calculationDetails: CalculationDetails) => void;
  isOverriding: boolean,
  control: Control<any>,
};

export const EstimatedUroaCell = ({ ndc, uroa, isOverriding, control, onViewCalculationDetails }: EstimatedUroaCellProps) => {
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const handleValueClick = () => onViewCalculationDetails(uroa.calculatedValue);

  const formKey = `${ndc}.uroa`;

  return (
    <div className="min-w-32">
      {isOverriding
        && <Controller
          control={control}
          name={formKey}
          render={({ field: { value, onChange, onBlur } }) => (
            <CurrencyTextInput
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              id={formKey}
              name={formKey}
            />
          )}
        />
      }

      {!isOverriding && uroa?.overrideValue != null
        && <span>{formatCurrency(uroa.overrideValue, 4, 4)}</span>
      }

      {!isOverriding && uroa?.overrideValue == null && uroa?.calculatedValue?.value != null
        && <ArtiaButtonLink onClick={handleValueClick}>
          {formatCurrency(uroa.calculatedValue.value, 4, 4)}
        </ArtiaButtonLink>
      }
    </div>
  );
};
